export default __webpack_public_path__ + "static/media/finance-management.0372bcf5.svg";